import type { SystemStyleObject } from '@chakra-ui/react';

export const surfaceCard: SystemStyleObject = {
  bg: 'bg.surface',
  borderWidth: '1px',
  borderColor: 'line.subtle',
  borderRadius: '12px',
};

export const monoLabel: SystemStyleObject = {
  fontFamily: 'mono',
  fontSize: '11px',
  letterSpacing: '0.16em',
  textTransform: 'uppercase',
  color: 'text.muted',
};

export const thinScrollbar: SystemStyleObject = {
  '&': { scrollbarWidth: 'thin' },
  '&::-webkit-scrollbar': { width: '8px' },
  '&::-webkit-scrollbar-track': { bg: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    bg: 'rgba(124, 116, 105, 0.25)',
    borderRadius: '999px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    bg: 'rgba(124, 116, 105, 0.5)',
  },
};
